import { Section, PrimaryButton } from "@/components/Section";
import { SEO } from "@/components/SEO";
import { site } from "@/config/site";

export default function About() {
    return (
        <>
            <SEO title="O nas – Szymkas Agency" description="Poznaj założyciela Szymkas Agency i naszą filozofię pracy." />
            <section className="bg-[#06111F] text-white pt-32 pb-16 md:pt-40 md:pb-20 relative overflow-hidden">
                <div className="absolute inset-0 bg-grid-faint opacity-50" />
                <div className="relative max-w-4xl mx-auto px-5 md:px-8 text-center">
                    <div className="text-xs font-semibold tracking-widest uppercase text-[#14B8A6] mb-3">O nas</div>
                    <h1 className="font-display font-extrabold text-[38px] md:text-[58px] lg:text-[64px] leading-[1.05] tracking-tight">
                        Za {site.companyName}<br /><span className="text-[#14B8A6]">stoi konkretna osoba</span>
                    </h1>
                </div>
            </section>
            <Section variant="light">
                <div className="grid lg:grid-cols-5 gap-10 md:gap-14 items-start">
                    <div className="lg:col-span-2">
                        <div className="relative aspect-[4/5] max-w-sm mx-auto rounded-[20px] overflow-hidden border border-[#E5E7EB] bg-gradient-to-br from-[#0F172A] to-[#06111F] shadow-xl">
                            <div className="absolute inset-0 bg-grid-faint opacity-30" />
                            <img
                                src={site.ownerPhoto}
                                alt={`${site.ownerName} – ${site.ownerRole}`}
                                className="relative w-full h-full object-cover object-top"
                                loading="lazy"
                                data-testid="owner-photo-about"
                            />
                            <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between text-white">
                                <span className="text-xs font-display font-semibold">SA</span>
                                <span className="text-[10px] tracking-widest uppercase text-[#14B8A6]">Założyciel</span>
                            </div>
                        </div>
                    </div>
                    <div className="lg:col-span-3 space-y-5 text-[#0B1220]/80 text-base md:text-lg leading-relaxed">
                        <p>Nazywam się <strong className="text-[#0B1220]">{site.ownerName}</strong>. Pomagam firmom budować profesjonalny wizerunek i skutecznie działać w internecie.</p>
                        <p>Łączę projektowanie, technologię, marketing oraz nowoczesne narzędzia AI, aby realizować projekty sprawniej i efektywniej niż w dużych, tradycyjnych agencjach. Dzięki temu mogę zaoferować profesjonalną jakość w przystępnej cenie.</p>
                        <p>Zależy mi na prostym procesie, jasnej komunikacji oraz rozwiązaniach, które wspierają realne cele biznesowe klienta. Wierzę, że małe i średnie firmy zasługują na takie samo zaangażowanie i jakość, jakie zwykle dostępne są tylko dla największych marek.</p>
                        <div className="pt-4">
                            <div className="font-display font-semibold text-[#0B1220]">{site.ownerName}</div>
                            <div className="text-sm text-[#0B1220]/60">{site.ownerRole}</div>
                        </div>
                        <div className="pt-4 flex flex-col sm:flex-row gap-3">
                            <PrimaryButton to="/kontakt" testid="about-cta">Porozmawiajmy o Twojej firmie</PrimaryButton>
                        </div>
                    </div>
                </div>
            </Section>
        </>
    );
}
